module.exports = __webpack_public_path__ + "media/images/setup_background-40ff7845bf362a4acaf46dc835ce6894.svg";